/* refund-policy.js */
import 'buefy/dist/buefy.css'
import './styles/global-styles-v1.css'